export default __webpack_public_path__ + "static/media/chart-1.2c6c7074.svg";